import React from 'react';
import { useHistory } from 'react-router-dom';
import { Icon } from '@weezevent/nacre';

function NavTitle({ title, link }) {
    const history = useHistory();

    const handleBack = React.useCallback(() => {
        history.push(link);
    }, [history, link]);

    return (
        <span>
            <Icon margin name="chevron-left" onClick={handleBack} size="regular" />
            {title}
        </span>
    );
}

export default NavTitle;
